/*

Append content of the "data-append-text" data attribute as it changes to the end of the attached element, normally a
text area. additionally if the user has scrolled to the bottom of the text area keep the scroll position at the bottom,
ie tail the changes.

inspired by: https://elixirforum.com/t/change-scroll-position-on-liveview-event/40115/6
note: updating content via a data attribute as LV won't update it if the user has changed the textarea or it has focus etc...
https://github.com/phoenixframework/phoenix_live_view/issues/624


Example usage:

<textarea
  id="recently_eaten_fruit_text_area"
  class="mdc-text-field__input"
  rows="20"
  cols="120"
  aria-label="Label"
  phx-hook="LogTailer"
  phx-update="ignore"
  data-append-text={@latest_fruit_feedback}
/>

Note: It's important to specify phx-update="ignore" so that LV won't change the TextArea content after first render as
it's now controlled by this hook
*/

export default {
  mounted() {
    this.el.value = this.el.value + this.el.dataset.appendText
    this.el.scrollTo(0, this.el.scrollHeight)

    this.handleEvent(
      'reset-log-tailer',
      ({ target, reloadLatestText = false }) => {
        if (target !== this.el.id) return
        if (reloadLatestText) this.el.value = this.el.dataset.appendText
        else this.el.value = ''
      }
    )
  },

  updated() {
    /*
    scrollHeight - measurement of the height of an element's content, including content not visible on the screen due to overflow.
    https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight

    clientHeight - height of visible element, includes padding, excludes margin and border
    https://developer.mozilla.org/en-US/docs/Web/API/Element/clientHeight

    scrollTop - pixel position of the top relative to the scrollHeight
    https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTop
    */

    // how much content is scrolled off the bottom
    const pixelsBelowBottom =
      this.el.scrollHeight - this.el.clientHeight - this.el.scrollTop

    this.el.value = this.el.value + this.el.dataset.appendText

    // 30% of the text area height, which is quite a big buffer but seems to work for our purposes
    // TODO: could make this configurable later, either % or fixed number of pixels
    const followUpdatesThreshold = this.el.clientHeight * 0.3

    if (pixelsBelowBottom < followUpdatesThreshold) {
      this.el.scrollTo(0, this.el.scrollHeight)
    }
  }
}
